import "./career.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import CareerOffers from "@frontend/js/Components/Site/CareerOffers/CareerOffers";
import ClientsList from "@frontend/js/Components/Shared/ClientsList/ClientsList";
import ImageLayer from "@frontend/js/Components/Shared/ImageLayer/ImageLayer";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import ArrowNextIcon from "@frontend/images/icons/ArrowNextIcon";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import CrossIcon from "@frontend/images/icons/CrossIcon";
import PlusIcon from "@frontend/images/icons/PlusIcon";
import fondator from "@frontend/images/fondator.png";
import { Link, usePage } from "@inertiajs/react";
import { useState } from "react";
import useT from "@frontend/js/hooks/useT";

export default function Career({
    page,
    collection = [],
    infoCollection = [],
    clients = [],
    blocks = [],
    meta = {},
}) {
    const { t } = useT("site");
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const pageTitle = page?.title?.[locale] || "";
    const vacancies = collection?.data || [];
    const [openedIndex, setOpenedIndex] = useState(null);
    const infoItems = infoCollection?.data || [];
    const firstBlock = blocks?.data?.["vacancies-block-1"] || null;
    const offerBlocks = [
        blocks?.data?.["vacancy-offer-block-1"],
        blocks?.data?.["vacancy-offer-block-2"],
        blocks?.data?.["vacancy-offer-block-3"],
        blocks?.data?.["vacancy-offer-block-4"],
    ].filter(Boolean);
    const founderBlock = blocks?.data?.["founder-message-block"] || null;
    const statisticBlocks = [
        blocks?.data?.["statistic-block-1"],
        blocks?.data?.["statistic-block-2"],
        blocks?.data?.["statistic-block-3"],
        blocks?.data?.["statistic-block-4"],
        blocks?.data?.["statistic-block-5"],
        blocks?.data?.["statistic-block-6"],
    ].filter(Boolean);

    const toggleItem = (index) => {
        setOpenedIndex((prev) => (prev === index ? null : index));
    };

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="career page-shell">
                    <PageTitleBreadcrumb title={pageTitle} />
                    {firstBlock && (
                        <div className="career__text">
                            <h2>{firstBlock.title_for_site}</h2>
                            <div
                                className="career__text__description"
                                dangerouslySetInnerHTML={{
                                    __html: firstBlock.content,
                                }}
                            />
                        </div>
                    )}
                    <div className="career__info">
                        <h2>{t("vacancy-info-title")}</h2>
                        <div className="career__info__list">
                            {infoItems.map((item, index) => {
                                const isOpen = openedIndex === index;

                                return (
                                    <div
                                        className={`career__info__list__item ${isOpen ? "is-open" : ""}`}
                                        key={index}
                                    >
                                        <button
                                            type="button"
                                            aria-expanded={isOpen}
                                            onClick={() => toggleItem(index)}
                                        >
                                            <h3>
                                                {item.title?.[locale] ||
                                                    item.title}
                                            </h3>

                                            {isOpen ? (
                                                <CrossIcon />
                                            ) : (
                                                <PlusIcon />
                                            )}
                                        </button>

                                        <div className="career__info__list__item__content">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        item.description?.[
                                                            locale
                                                        ] || item.description,
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="career__vacancies">
                        {vacancies.length && (
                            <div className="career__vacancies__list">
                                <h2>{t("vacancies-title")}</h2>
                                <div className="career__vacancies__list__items">
                                    {vacancies.map((vacancy, vIndex) => (
                                        <Link
                                            key={vacancy.slug || vIndex}
                                            href={vacancy.href}
                                            className="career__vacancies__list__items__item"
                                        >
                                            <h3>{vacancy.title}</h3>
                                            <div className="career__vacancies__list__items__item__date">
                                                <span>{vacancy.date}</span>
                                                <ArrowNextIcon />
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                        <CareerOffers offerBlocks={offerBlocks} />
                    </div>

                    {founderBlock && (
                        <div className="career__message">
                            <h2>{founderBlock.title_for_site}</h2>
                            <div className="career__message__content">
                                <ImageLayer>
                                    <img
                                        src={`/storage/block/${founderBlock.id}/${founderBlock.image}`}
                                        alt=""
                                    />
                                </ImageLayer>
                                <div
                                    className="career__message__content__text"
                                    dangerouslySetInnerHTML={{
                                        __html: founderBlock.content,
                                    }}
                                />
                            </div>
                        </div>
                    )}
                    <div className="career__statistic">
                        <div className="career__statistic__title">
                            <h2>{t("vacancy-statistic-title")}</h2>
                            <p>{t("vacancy-statistic-description")}</p>
                        </div>
                        <div className="career__statistic__cards">
                            {statisticBlocks.map((block, index) => (
                                <div
                                    className="career__statistic__cards__card"
                                    key={index}
                                >
                                    <h3
                                        dangerouslySetInnerHTML={{
                                            __html: block.title_for_site,
                                        }}
                                    />
                                    <div className="career__statistic__cards__card__info">
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: block.content,
                                            }}
                                        />
                                        <span>{block.button_text}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="career__clients">
                        <div className="career__clients__title">
                            <h2>{t("vacancy-clients-title")}</h2>
                            <p>{t("vacancy-clients-description")}</p>
                        </div>
                        <ClientsList clients={clients} />
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
